export const OTP_PAGE_FORM_DEFAULT_VALUES = Object.freeze({});
